var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"testContainer"}},[_vm._v("404，出错了")]),_c('div',{staticClass:"center"})])}]

export { render, staticRenderFns }